<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<mat-card class="content-card">
  <mat-card-content>
  <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="20">
      <div style="padding: 15px;">
        <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
      </div>
    </div>
    <div fxFlex="60" style="text-align: center;">
      <h3 class="h-condensed">Card<span *ngIf="chargeback && card"> Chargeback on <span *ngIf="card.primaryCardId"> ⛓</span> {{ card.token }} (#{{ chargeback.id }})</span></h3>
    </div>
    <div fxFlex="20">

    </div>
  </div>
  </mat-card-content>
</mat-card>




<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="40">

    <mat-card class="content-card">

          <div *ngIf="chargeback" style="text-align: center;" class="w-100">
            Status: <span *ngIf="chargeback.status == chargebackStatus.Request" style="color: blue; letter-spacing: 2px;">REQUESTED</span>
            <span *ngIf="chargeback.status == chargebackStatus.Pending" style="color: orange; letter-spacing: 2px;">PENDING</span>
            <span *ngIf="chargeback.status == chargebackStatus.Denied" style="color: red; letter-spacing: 2px;">DENIED</span>
            <span *ngIf="chargeback.status == chargebackStatus.SuccessPending" style="color: darkslategray; letter-spacing: 2px;">APPROVED</span>
            <span *ngIf="chargeback.status == chargebackStatus.ChargebackExecuted" style="color: forestgreen; letter-spacing: 2px;">CHARGED BACK</span>
          </div>

      <mat-card-content>

        <h5 class="h-condensed" style="margin-left: 10px;">Information</h5>
        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsChargeback">
          <app-content-row [field]="field" [entity]="chargeback"></app-content-row>
        </div>

        <h5 class="h-condensed" style="margin-left: 10px; margin-top: 10px;">Files</h5>
        <div style="margin: 10px;">
          <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
            <tr>
              <th style="text-align: left;"><label>Type</label></th>
              <th style="text-align: left; width: 120px;"></th>
            </tr>



            <ng-container  *ngFor="let ftc of filesList">
              <tr [class.noborderbottom]="true">

                <td>
                  <label>{{ getChargebackUploadTypeText(ftc) }}</label><br />
                  <span style="font-size: 10px; font-family: monospace">
                    {{ ftc.file.originalFileName }}
                  </span>
                </td>

                <td style="padding-top: 5px;">
                  <button style="margin-right: 5px;" aria-label="download" color="accent" mat-mini-fab>
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                  <button (click)="openFile(ftc.file.id)" aria-label="preview" color="primary" mat-mini-fab>
                    <mat-icon matSuffix>play_arrow</mat-icon>
                  </button>
                </td>

              </tr>

            </ng-container>
          </table>
        </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>

          <h5 class="h-condensed">Transaction Detail</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div *ngIf="txnDetail">

          <div *ngIf="gpsPosData" style="font-size: .9em; margin-left: 10px; font-family: monospace; margin-bottom: 2px;" >

            <span class="posDataBadge large posDataGood" *ngIf="(gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Passed">3DS ok</span>
            <span class="posDataBadge large posDataBad" *ngIf="(gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Failed">3DS fail</span>
            <!--<span class="posDataBadge" *ngIf="(element.gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.NotPerformed">No 3DS</span>-->

            <span [matTooltip]="'Card present'" class="posDataBadge large posDataGood" *ngIf="(gpsPosData?.cardPresent ?? CardPresent.Unknown) == CardPresent.Present">💳✅</span>
            <span [matTooltip]="'Card not present'" class="posDataBadge large posDataWarn" *ngIf="(gpsPosData?.cardPresent ?? CardPresent.Unknown) == CardPresent.NotPresent">💳❌</span>
            <span [matTooltip]="'Cardholder present'" class="posDataBadge large posDataGood" *ngIf="(gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.Present">🙋✅</span>
            <span [matTooltip]="'Cardholder not present'" class="posDataBadge large posDataWarn" *ngIf="(gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.NotPresentUnspecified || (gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">🙋❌</span>

            <span class="posDataBadge large posDataInfo" *ngIf="(gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.RecurringTransaction">Recurring Txn</span>
            <span class="posDataBadge large posDataBad" *ngIf="(gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.TelephoneOrder">Tel. order</span>
            <span class="posDataBadge large posDataBad" *ngIf="(gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.MailOrder">Mail order</span>


            <span class="posDataBadge large posDataInfo" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ECommerce || (gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">ECommerce</span>

            <span class="posDataBadge large posDataInfo" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.EMVContactless">EMV Contactless</span>
            <span class="posDataBadge large posDataGood" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ChipDip">ChipDip</span>
            <span class="posDataBadge large posDataWarn" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.AccountDataOnFile">Acct.Data on File</span>
            <span class="posDataBadge large posDataBad" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.MagneticStripeRead">Mag. Stripe Read</span>
            <span class="posDataBadge large posDataBad" *ngIf="(gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ContactlessMagStripe">Contactless Mag. Stripe</span>


            <span class="posDataBadge large posDataGood" *ngIf="isPinAuth(gpsPosData)">🔐 PIN</span>
            <span class="posDataBadge large posDataGood" *ngIf="isSecure3DsAuth(gpsPosData)">🔐 3DS</span>
            <span class="posDataBadge large posDataGood" *ngIf="isBiometricsAuth(gpsPosData)">🔐 Biometrics</span>

          </div>


          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsTransactionDetail">
            <app-content-row [field]="field" [entity]="txnDetail"></app-content-row>
          </div>


        </div>




        <br />


      </mat-card-content>

    </mat-card>

    <mat-card class="content-card">
      <mat-card-content>

        <img *ngIf="imageUrl" class="logo-large" [src]="imageUrl" height="50" style="margin-left: 15px;" />

        <div *ngIf="card && card.primaryCardId" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex="100">
            <div style="background-color: #e0da67; padding: 5px; margin-left: 10px; margin-right: 10px; margin-top: 5px; border-radius: 3px;">
              This card is a secondary card of {{ chargeback.card.primaryToken }}.
            </div>

          </div>
        </div>


        <div *ngIf="chargeback">

          <h5 class="h-condensed" style="margin-left: 10px;">Customer</h5>
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
            <app-content-row [field]="field" [entity]="chargeback.customer"></app-content-row>
          </div>


          <h5 class="h-condensed" style="margin-left: 10px;">Card</h5>

          <div class="list-item" fxLayout="row" *ngFor="let field of fields1">
            <app-content-row [field]="field" [entity]="chargeback.card"></app-content-row>
          </div>

          <div class="list-item" fxLayout="row" *ngFor="let field of fields2">
            <app-content-row [field]="field" [entity]="chargeback.card"></app-content-row>
          </div>

          <h3>Transaction</h3>

          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsTransaction">
            <app-content-row [field]="field" [entity]="chargeback"></app-content-row>
          </div>

        </div>




        <br />


      </mat-card-content>


    </mat-card>



  </div>



  <div fxFlex="60">

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Chargeback Actions</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngIf="chargeback">

          <div style="margin-left: 15px;">
            <h5>Status</h5>
          </div>



          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary">New chargeback status</label>
            <label fxFlex="33" style="text-align: right">
              <mat-select placeholder="Select new chargeback status" [(value)]="newChargebackStatusToSet">

                <mat-option [value]="chargebackStatus.Request">Requested</mat-option>
                <mat-option [value]="chargebackStatus.Pending">Pending</mat-option>
                <mat-option [value]="chargebackStatus.Denied">Denied</mat-option>
                <mat-option [value]="chargebackStatus.SuccessPending">Approved</mat-option>
                <mat-option [value]="chargebackStatus.ChargebackExecuted">Charged back</mat-option>

              </mat-select>
            </label>
            <label fxFlex="33" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
                <button [class.spinner]="_isSettingChargebackStatus" [disabled]="_isSettingChargebackStatus || newChargebackStatusToSet == null" mat-raised-button color="primary" (click)="setChargebackStatus()">Set new status</button>
              </ng-container>
            </label>
          </div>


        </ng-container>

      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>


    <app-object-comments-view [caption]="'Comments'" [target]="commentsChargebackTarget" [objectId]="chargebackId" [comments]="chargebackComments"></app-object-comments-view>
    <app-event-log-view [logs]="logs" *ngIf="showLogs()"></app-event-log-view>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Card Operations</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngIf="card">

          <div style="margin-left: 15px;">
            <h5>Status</h5>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="33" class="secondary">Current Card Status (Portal / APP)</label>
            <label fxFlex="33" style="text-align: right">
              <div>
                {{ currentGpsStatusCached }}:&nbsp;
                <span>{{ gpsCardStatusHelper.getIcon(currentGpsStatusCached) }} {{ gpsCardStatusHelper.getText(currentGpsStatusCached) }}</span>

              </div>

            </label>

            <label fxFlex="33" style="text-align: right">

            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="33" class="secondary">Current Card Status (GPS)</label>
            <label fxFlex="33" style="text-align: right">
              <div>
                <ng-container *ngIf="!currentGpsStatus; else hasStatus">
                  <i>please query if necessary</i>
                </ng-container>
                <ng-template #hasStatus>
                  {{ currentGpsStatus }}:&nbsp;
                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllGood">🟢 All Good</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ReferToCardIssuer">🟡 Refer to card issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardNotYetActivated">🟡 Card not yet activated</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CaptureCard">🔴 Capture card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.DoNotHonour">🔴 Do not honour</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.InvalidCard">🔴 Invalid card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LostCard">🟡 Lost card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.StolenCard">🟠 Stolen card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ClosedAccount">⚫️ Closed Account</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ExpiredCard">⚪️ Expired card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡 Transaction not permitted to cardholder</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SuspectedFraud">🔴 Suspected fraud</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RestrictedCard">🔴 Restricted card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SecurityViolation">🔴 Security violation</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardholderToContactIssuer">🔴 Cardholder to contact issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllowableNumberOfPinTriesExceeded">Allowable number of PIN tries exceeded</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardDestroyed">🔴 Card destroyed</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RefundGivenToCustomer">🔴 Refund given to customer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardVoided">⚫️ Card voided</span>

                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermBlock">🟡 Short Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermFullBlock">🟡 Short Term Full Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermBlock">🟠 Long Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermFullBlock">🟠 Long Term Full Block</span>
                </ng-template>
              </div>

            </label>

            <label fxFlex="33" style="text-align: right">
              <div *ngIf="!currentUserIsPartner()">
                <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-stroked-button color="primary" (click)="queryCardStatusFromPortal()">Query current card status</button>
              </div>
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary">New card status</label>
            <label fxFlex="33" style="text-align: right">
              <mat-select placeholder="Select new card status" [(value)]="newGpsStatusToSet">

                <mat-option [value]="gpsCardStatus.AllGood">00 - All Good</mat-option>
                <mat-option [value]="gpsCardStatus.ReferToCardIssuer">01 - Refer to card issuer</mat-option>
                <mat-option [value]="gpsCardStatus.CardNotYetActivated">02 - Card not yet activated</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.CaptureCard">04 - Capture card</mat-option>
                <mat-option [value]="gpsCardStatus.DoNotHonour">05 - Do not honour</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.InvalidCard">14 - Invalid card</mat-option>
                <mat-option [value]="gpsCardStatus.LostCard">41 - Lost card</mat-option>
                <mat-option [value]="gpsCardStatus.StolenCard">43 - Stolen card</mat-option>
                <mat-option [value]="gpsCardStatus.ClosedAccount">46 - Closed Account</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.ExpiredCard">54 - Expired card</mat-option>
                <mat-option [value]="gpsCardStatus.TransactionNotPermittedToCardholder">57 - Transaction not permitted to cardholder</mat-option>
                <mat-option [value]="gpsCardStatus.SuspectedFraud">59 - Suspected fraud</mat-option>
                <mat-option [value]="gpsCardStatus.RestrictedCard">62 - Restricted card</mat-option>
                <mat-option [value]="gpsCardStatus.SecurityViolation">63 - Security violation</mat-option>
                <mat-option [value]="gpsCardStatus.CardholderToContactIssuer">70 - Cardholder to contact issuer</mat-option>
                <mat-option [value]="gpsCardStatus.AllowableNumberOfPinTriesExceeded">75 - Allowable number of PIN tries exceeded</mat-option>
                <mat-option [value]="gpsCardStatus.CardDestroyed">83 - Card destroyed</mat-option>
                <mat-option [value]="gpsCardStatus.RefundGivenToCustomer">98 - Refund given to customer</mat-option>
                <mat-option [value]="gpsCardStatus.CardVoided">99 - Card voided</mat-option>

                <mat-option [value]="gpsCardStatus.ShortTermBlock">G1 - Short Term Block</mat-option>
                <mat-option [value]="gpsCardStatus.ShortTermFullBlock">G2 - Short Term Full Block</mat-option>
                <mat-option [value]="gpsCardStatus.LongTermBlock">G3 - Long Term Block</mat-option>
                <mat-option [value]="gpsCardStatus.LongTermFullBlock">G4 - Long Term Full Block</mat-option>
              </mat-select>
            </label>
            <label fxFlex="33" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
                <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus || newGpsStatusToSet == null" mat-raised-button color="primary" (click)="setGpsCardStatus(newGpsStatusToSet)">Set card status</button>
              </ng-container>
            </label>
          </div>


        </ng-container>

      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>


    <div style="" class="content-card full-card w-100">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>🔮 Card Processor Enquiry</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-expansion-panel disabled=true>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Card
              </mat-panel-title>
              <mat-panel-title>
                Token
              </mat-panel-title>
              <mat-panel-title>
                Exp.
              </mat-panel-title>
              <mat-panel-title>
                Status
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel *ngFor="let card of customerCards">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div  style="width: 150px;">{{card.card.product.shortName}}</div>
              </mat-panel-title>
              <mat-panel-title>
                <div  style="width: 120px;" *ngIf="chargeback && card" [style.font-weight]="card.card.token == chargeback.card.token ? 'bold' : 'normal'"  [style.color]="card.card.token == chargeback.card.token ? 'blue' : null">
                  {{card.card.token}} <span *ngIf="card.card.primaryCardId">⛓</span>
                </div>
              </mat-panel-title>
              <mat-panel-title  style="width: 80px;">
                {{card.card.expireDate | date: 'MM/yy'}}
              </mat-panel-title>
              <mat-panel-title class="{{card.card.status == 6 ? 'warning-row' : ''}}">
                <div style="width: 150px;">{{card.card.statusName}}</div>

              </mat-panel-title>
            </mat-expansion-panel-header>

            <button mat-raised-button color="primary" (click)="getStatement(card)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get statement</button>
            <button mat-raised-button color="primary" (click)="getCardholderDetails(card)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get cardholder details</button>
            <button mat-raised-button color="primary" (click)="getCardInfos(card)" [disabled]="!isGpsButtonEnabled()">Get card infos</button>

            <small style="color: red; margin-left: 20px;">Enquiries will be logged!</small>



            <div [hidden]="!isStatementLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>

            <div *ngIf="card.statement && card.statement.financialTransactions" style="margin-top: 10px;" class="statement">
              <h4>Statement - last year</h4>
              <table mat-table matSort [dataSource]="card.financialStatements" class="mat-elevation-z8" style="width: 100%;">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <ng-container matColumnDef="direction">
                  <th mat-header-cell *matHeaderCellDef style="width: 25px;"></th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.type === 'A' && element.statusCode === 'A'">⌛️</ng-container>
                    <ng-container *ngIf="element.type === 'D' && element.statusCode === 'A'">↩️️</ng-container>
                    <ng-container *ngIf="element.type === 'L'">💰</ng-container>
                    <ng-container *ngIf="element.type === 'U'">💸</ng-container>
                    <ng-container *ngIf="element.type === 'P' && element.statusCode === 'S'">✅</ng-container>
                    <ng-container *ngIf="element.type === 'B' && element.isCredit">🔼</ng-container>
                    <ng-container *ngIf="element.type === 'B' && !element.isCredit">🔽</ng-container>
                    <ng-container *ngIf="element.statusCode === 'I'">⛔️</ng-container>

                  </td>
                </ng-container>

                <ng-container matColumnDef="transactionDate">
                  <th mat-header-cell *matHeaderCellDef style="width: 100px;">Date</th>
                  <td mat-cell *matCellDef="let element"> {{ element.transactionDate | date:'dd.MM.yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef style=""> Description </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="txn-description">{{element.description}}</div>
                    <div *ngIf="element.note" style="font-size: .9em; font-family: monospace;" [class]="'statement-note-' + element.statusCode">
                      📝 {{element.note}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Amt. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <div [class]="'amount-' + element.statusCode">
                      {{element.amount.toFixed(2)}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="blockAmount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Blk. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.blockedAmount">
                      {{element.blockedAmount.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="billAmount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Bill </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.billAmount.toFixed(2)}} </td>
                </ng-container>

                <ng-container matColumnDef="currency">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: center;"> Cur. </th>
                  <td mat-cell *matCellDef="let element" style=" text-align: center;"> {{element.currency}} </td>
                </ng-container>

                <ng-container matColumnDef="rateFee">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Rate f. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.rateFee">
                      {{element.rateFee.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="fixedFee">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Fixed f. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.fixedFee">
                      {{element.fixedFee.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>


                <ng-container matColumnDef="statusDescription">
                  <th mat-header-cell *matHeaderCellDef style="width: 80px;  text-align: center;"> Status </th>
                  <td mat-cell *matCellDef="let element" style=" text-align: right;">
                    <div [class]="'status-' + element.statusCode">
                      {{ element.statusDescription }}
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedStatementColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedStatementColumns;" class="txn-row"></tr>
              </table>
            </div>

            <div [hidden]="!isCardholderDetailsLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="card.cardholderDetails">
              <h4>Cardholder details</h4>
              <div mat-dialog-content>
                <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardholderDetails ">
                  <label fxFlex="35" class="secondary">{{ field.header }}</label>
                  <label fxFlex="65" *ngIf="card.cardholderDetails">{{ field.cell(card.cardholderDetails) }}</label>
                </div>
              </div>
            </div>

            <div [hidden]="!isCardInfoLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="card.cardInfo">
              <h4>Card infos</h4>
              <div mat-dialog-content>
                <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardInfo ">
                  <label fxFlex="35" class="secondary">{{ field.header }}</label>
                  <label fxFlex="65" *ngIf="card.cardInfo">{{ field.cell(card.cardInfo) }}</label>
                </div>
              </div>
            </div>

          </mat-expansion-panel>




        </mat-card-content>
      </mat-card>
    </div>


  </div>
</div>




<div *ngIf="!isFrameHidden || !isImgHidden" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 9999; background-color: rgba(211,211,211,0.09)">

  <div style="text-align: right">
    <button (click)="this.isImgHidden = true; this.isFrameHidden = true;">Close</button>
  </div>

  <iframe [hidden]="isFrameHidden" [src]="urlSafe" class="resp-iframe" frameBorder="1" height="1000" width="100%">
  </iframe>
  <img [hidden]="isImgHidden" [src]="urlSafe" style="width: 100%; height:auto;"/>
</div>
